module.exports = __webpack_public_path__ + "img/abbie.8119b929.png";